module.exports = __webpack_public_path__ + "static/media/bg.42d2146c.svg";